// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__3qvgp","Div":"CustomFadeBox_Div__THE0h","LargeDiv":"CustomFadeBox_LargeDiv__2Pzg2"};